<template>
  <nav class="rail-nav">
    <div class="rail-nav__logo" title="Ekspertiza">E</div>

    <router-link
      v-for="item in items"
      :key="item.to"
      :to="item.to"
      class="rail-nav__item"
      :class="{ 'is-active': isActive(item) }"
      :title="item.label"
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <template v-if="item.icon === 'home'">
          <path d="M4 10.5 12 4l8 6.5V20a1 1 0 0 1-1 1h-4v-6H9v6H5a1 1 0 0 1-1-1z"></path>
        </template>
        <template v-else-if="item.icon === 'list'">
          <rect x="3" y="4" width="18" height="16" rx="2"></rect>
          <line x1="3" y1="9" x2="21" y2="9"></line>
          <line x1="9" y1="9" x2="9" y2="20"></line>
        </template>
        <template v-else-if="item.icon === 'chart'">
          <line x1="4" y1="19" x2="4" y2="11"></line>
          <line x1="10" y1="19" x2="10" y2="5"></line>
          <line x1="16" y1="19" x2="16" y2="13"></line>
          <line x1="21.5" y1="19" x2="2.5" y2="19"></line>
        </template>
        <template v-else>
          <path d="M12 3l7 3v6c0 4-3 7.5-7 9-4-1.5-7-5-7-9V6l7-3z"></path>
        </template>
      </svg>
      <span class="rail-nav__tip">{{ item.label }}</span>
    </router-link>
  </nav>
</template>

<script>
import { isAdmin, canViewReports } from "@/models/admin";

export default {
  name: "SideMenu",
  computed: {
    items() {
      const items = [
        { to: "/", label: "Početna", icon: "home", exact: true },
        { to: "/predmeti", label: "Predmeti", icon: "list" },
      ];
      if (canViewReports()) {
        items.push({ to: "/reports", label: "Izvještaji", icon: "chart" });
      }
      if (isAdmin()) {
        items.push({ to: "/admin", label: "Administracija", icon: "shield" });
      }
      return items;
    },
  },
  methods: {
    isActive(item) {
      if (item.exact) return this.$route.path === "/";
      // "Predmeti" stays lit on the case screens, which live under it.
      if (item.to === "/predmeti") return this.$route.path.startsWith("/predmet");
      return this.$route.path.startsWith(item.to);
    },
  },
};
</script>

<style lang="scss" scoped>
.rail-nav {
  width: 52px;
  height: 100%;
  background: var(--navy);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px 0;
  gap: 6px;
  box-sizing: border-box;
}

.rail-nav__logo {
  width: 28px;
  height: 28px;
  border-radius: var(--r-md);
  background: var(--brand);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--fs-xl);
  font-weight: 700;
  margin-bottom: 10px;
  flex-shrink: 0;
}

.rail-nav__item {
  position: relative;
  width: 36px;
  height: 36px;
  border-radius: var(--r-md);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8fa3bd;
  text-decoration: none;
  transition: background 0.12s, color 0.12s;

  &:hover {
    background: rgba(255, 255, 255, 0.08);
    color: #dce6f2;
  }

  &.is-active {
    background: rgba(255, 255, 255, 0.12);
    color: #fff;
  }
}

// Icon-only rail, so each item names itself on hover.
.rail-nav__tip {
  position: absolute;
  left: 46px;
  top: 50%;
  transform: translateY(-50%);
  background: var(--ink);
  color: #fff;
  font-size: var(--fs-sm);
  line-height: 1;
  padding: 6px 9px;
  border-radius: var(--r-sm);
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.12s;
  z-index: 20;
}

.rail-nav__item:hover .rail-nav__tip {
  opacity: 1;
}
</style>
